import { render, staticRenderFns } from "./TalentAnalysisReport.vue?vue&type=template&id=47e31c2c&scoped=true&"
import script from "./TalentAnalysisReport.vue?vue&type=script&lang=js&"
export * from "./TalentAnalysisReport.vue?vue&type=script&lang=js&"
import style0 from "./TalentAnalysisReport.vue?vue&type=style&index=0&id=47e31c2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e31c2c",
  null
  
)

export default component.exports